import React from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  variant = 'default',
  loading = false
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    default: 'bg-blue-500 hover:bg-blue-600',
    danger: 'bg-red-500 hover:bg-red-600',
    warning: 'bg-yellow-500 hover:bg-yellow-600',
    success: 'bg-green-500 hover:bg-green-600'
  };

  const iconNames = {
    default: 'AlertCircle',
    danger: 'AlertTriangle',
    warning: 'AlertCircle',
    success: 'CheckCircle'
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-start space-x-4">
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
            variant === 'danger' ? 'bg-red-100' :
            variant === 'warning' ? 'bg-yellow-100' :
            variant === 'success'? 'bg-green-100' : 'bg-blue-100'
          }`}>
            <Icon 
              name={iconNames?.[variant] || 'AlertCircle'} 
              size={20} 
              className={`${
                variant === 'danger' ? 'text-red-600' :
                variant === 'warning' ? 'text-yellow-600' :
                variant === 'success'? 'text-green-600' : 'text-blue-600'
              }`}
            />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-sm text-gray-600">{message}</p>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button
            className={variantStyles?.[variant]}
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;